exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-tlist[data-v-c89ff0b4] {\n  border: none;\n}", ""]);

// exports
